module.exports = __webpack_public_path__ + "media/images/recik4d-d79d5b8d.svg";